import {differenceInHours, format, formatDistance} from 'date-fns'

/**
 * Look pre-defined formats from date-fns documentation:
 * https://date-fns.org/v2.29.3/docs/format
 *
 * Examples:
 * DATE = 10/01/2023
 * DATE_STRING = 10. Feb 2023
 * TIME = 15:30
 * */

export enum DateFormat {
  DATE = 'dd/MM/yyyy',
  DATE_WITH_TIME = 'dd/MM/yyyy HH:mm',
  MONTH_YEAR = 'MMMM yyyy',
  TIME = 'HH:mm',
}

export function getISOTimeFormat() {
  return new Date().toISOString()
}

export function getDateFromTimestamp(timestamp: string): Date {
  return new Date(timestamp)
}

export function getFormattedDateString(timestamp: string, dateFormat: DateFormat) {
  const date: Date = getDateFromTimestamp(timestamp)
  return format(date, dateFormat)
}

export function getDateDistance(timestamp: string) {
  return formatDistance(new Date(timestamp), new Date(), {addSuffix: true})
}

export function getDateOrTimeDiff(
  timestamp: string,
  daysToDisplayTime: number
) {
  const dateNow = new Date()
  const dateEnd = new Date(timestamp)

  const diffInHours = Math.abs(differenceInHours(dateEnd, dateNow))

  if (diffInHours < daysToDisplayTime * 24) {
    return formatDistance(dateEnd, dateNow, {addSuffix: true})
  }

  return getFormattedDateString(timestamp, DateFormat.DATE)
}

export function formatDate(timestamp: string, dateFormat: DateFormat) {
  const date: Date = getDateFromTimestamp(timestamp)
  return format(date, dateFormat)
}

export const compareDates = (date: Date, compareDate: Date): boolean => {
  const dateString = getFormattedDateString(date.toString(), DateFormat.DATE)
  const compareDateString = getFormattedDateString(compareDate.toString(), DateFormat.DATE)
  return dateString === compareDateString
}
